import { lazy } from "react"
import type { CustomRoute } from "@/shared/types"

const RootComponent = lazy(() => import("@/pages/dashboard/root"))

export const rootRoutes: CustomRoute = {
  path: "root",
  handle: { hide: true },
  Component: RootComponent
}
